import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { scrollToElement } from "@utils/utilsScrollToElement";

/**
 * Porta la vista sull'elemento indicato dall'hash della URL.
 * `ready` permette di attendere il caricamento dei dati della pagina,
 * evitando che il layout si sposti dopo lo scroll.
 */
export const useScrollToHash = (ready: boolean = true) => {
  const { hash } = useLocation();
  const handledHash = useRef<string>();

  useEffect(() => {
    if (!ready || !hash || handledHash.current === hash) return;
    handledHash.current = hash;
    scrollToElement(hash.slice(1));
  }, [hash, ready]);
};
